import { BaseModel } from '../../_base/crud';

export class RelationshipCategory extends BaseModel {
  id: number;
  entity_type: string;
  name: string;
}
